"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

import { pushEvent } from "@/lib/analytics";

export function GtmPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const hasSkippedInitial = useRef(false);

  useEffect(() => {
    // The container sends its own page_view on load, so the first client
    // render is skipped to avoid counting the landing page twice.
    if (!hasSkippedInitial.current) {
      hasSkippedInitial.current = true;
      return;
    }

    const query = searchParams.toString();

    pushEvent({
      event: "page_view",
      page_path: query ? `${pathname}?${query}` : pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, searchParams]);

  return null;
}
